import { NgModule } from '@angular/core';
import { PurchaseHistoryPipe } from './purchase-history.pipe';

@NgModule({
    declarations: [PurchaseHistoryPipe],
    exports: [PurchaseHistoryPipe],
})
export class PurchaseHistoryPipeModule {}
